const SIDE_W = { S: 32, E: 22, W: 16, N: 8 };

export function solarColor(s) {
  return s >= 60 ? "#34D399" : s >= 32 ? "#F59E0B" : "#F43F5E";
}

export function computeSolar(rooms, items, season = "Equinox") {
  if (!rooms || !rooms.length) return { scored: [], byId: {}, avg: 0, dark: 0, season };
  const bbox = {
    MINX: Math.min(...rooms.map((r) => r.x)), MINY: Math.min(...rooms.map((r) => r.y)),
    MAXX: Math.max(...rooms.map((r) => r.x + r.w)), MAXY: Math.max(...rooms.map((r) => r.y + r.h)),
  };
  const DAY = { Summer: 14, Equinox: 12, Winter: 9.5 };
  const dayLen = DAY[season] || 12;
  const win = (items || []).filter((it) => it.kind === "window");
  const scored = rooms.map((r) => {
    const ext = {
      W: r.x <= bbox.MINX + 0.5, E: r.x + r.w >= bbox.MAXX - 0.5,
      N: r.y <= bbox.MINY + 0.5, S: r.y + r.h >= bbox.MAXY - 0.5,
    };
    const windows = win.filter((it) => it.x >= r.x - 1 && it.x <= r.x + r.w + 1 && it.y >= r.y - 1 && it.y <= r.y + r.h + 1).length;
    let exposure = 0;
    Object.keys(ext).forEach((s) => { if (ext[s]) exposure += SIDE_W[s]; });
    const score = Math.round(Math.min(100, 15 + exposure * (windows > 0 ? 1 : 0.5)));
    // Seasonal sun-hours per day
    let h = 0;
    if (ext.S) h += season === "Winter" ? 5 : season === "Summer" ? 3.5 : 4.3;
    if (ext.E) h += 2.6;
    if (ext.W) h += 2.6;
    if (ext.N) h += season === "Summer" ? 2.2 : 0.9;
    h = Math.min(dayLen, h * (windows > 0 ? 1 : 0.5));
    const sunHours = Math.round(h * 10) / 10;
    const faces = Object.keys(ext).filter((s) => ext[s]).join("/") || "interior";
    return { id: r.id, name: r.name, score, windows, faces, sunHours, dark: score < 32 };
  }).sort((a, b) => b.score - a.score);
  const byId = {};
  scored.forEach((s) => { byId[s.id] = s.score; });
  const avg = Math.round(scored.reduce((s, r) => s + r.score, 0) / scored.length);
  return { scored, byId, avg, dark: scored.filter((r) => r.dark).length, season };
}
